module.exports = __webpack_public_path__ + "img/map-maker-meter.3aad54d4.png";